function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13251",
  width: 24,
  height: 24,
  transform: "translate(1.329)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68628",
  transform: "translate(-1.329)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148551",
  d: "M10,18.742a9.136,9.136,0,0,0,9.079-9.079A9.144,9.144,0,0,0,9.991.584,9.134,9.134,0,0,0,.921,9.663,9.136,9.136,0,0,0,10,18.742ZM5.087,13.021V5.849a.563.563,0,0,1,1.125,0V9.312L7.267,8.239a.935.935,0,0,1,1.433,0l1.52,1.582c.044.053.079.053.114-.009l1.573-1.6-.6-.589a.421.421,0,0,1,.246-.712l2.558-.65a.435.435,0,0,1,.536.527L13.99,9.347a.42.42,0,0,1-.712.255l-.606-.615L11,10.7a1.023,1.023,0,0,1-.729.334.985.985,0,0,1-.721-.334L8.04,9.136c-.044-.053-.079-.053-.123,0L6.212,10.867V12.59c0,.062.026.088.079.088h8.016a.566.566,0,0,1,.563.563.559.559,0,0,1-.562.554H5.86A.724.724,0,0,1,5.087,13.021Z",
  transform: "translate(3.423 2.041)"
}));

function SvgFilledFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFunnel);
export default __webpack_public_path__ + "static/media/filled-funnel.6462cf2a.svg";
export { ForwardRef as ReactComponent };